module.exports = __webpack_public_path__ + "img/vertical_3_1_9006.44a03642.png";